import { createComponentInstance } from '@/utils/mount-component'
import { inBrowser } from '@/utils'
import FloatingMatchStatus from './FloatingMatchStatus.vue'

let instance

const DEFAULT_OPTIONS = {
  currentAvatarUrl: '', // 当前显示的头像 URL（由 useRandomMatch 提供）
}

let currentOptions = Object.assign({}, DEFAULT_OPTIONS)

function initInstance() {
  instance = createComponentInstance(FloatingMatchStatus)
}

/**
 * Show floating match status (纯 UI 组件，业务逻辑在 useRandomMatch 中)
 * @param {Object} options - Modal options
 * @param {import('vue').ComputedRef<string>} options.currentAvatarUrl - Computed ref for current avatar URL (from useRandomMatch)
 * @param {Function} options.onCancel - Callback when cancel button is clicked
 * @returns {void}
 */
export function showFloatingMatchStatus(options) {
  if (!inBrowser) {
    return
  }

  if (!instance) {
    initInstance()
  }

  const mergedOptions = Object.assign({}, currentOptions, options)

  // Wrap callbacks
  const originalOnCancel = mergedOptions.onCancel

  instance.open(
    Object.assign({}, mergedOptions, {
      onCancel: () => {
        if (originalOnCancel) {
          originalOnCancel()
        }
        instance.toggle(false)
      },
      onClosed: () => {
        if (instance?.unmount) {
          instance.unmount()
          instance = null
        }
      },
    })
  )
}

/**
 * Close the currently displayed floating match status
 */
export function closeFloatingMatchStatus() {
  if (instance) {
    instance.toggle(false)
  }
}
